import { Component, Input } from '@angular/core';
import { IContentSection } from '../../../../shared/interfaces/card-info.interface';
import { RevealDirective } from '../../../../shared/directives/reveal.directive';

@Component({
  selector: 'app-icon-section',
  imports: [RevealDirective],
  templateUrl: './icon-section.html',
  styleUrl: './icon-section.scss'
})
export class IconSection {
  /** Supplies heading + lead/outro copy (kept in the data files so copy never drifts). */
  @Input({ required: true }) section!: IContentSection;

  /** Large app-icon graphic path. */
  @Input({ required: true }) icon!: string;

  /** Which side the icon sits on (desktop). Text hugs the opposite side. */
  @Input() iconSide: 'left' | 'right' = 'left';

  /** All body paragraphs (lead + outro), minus any "Services include:" eyebrow line. */
  get paragraphs(): string[] {
    const lead = this.section.lead ?? [];
    const outro = this.section.outro ?? [];
    return [...lead, ...outro].filter((p) => !/^\s*services include/i.test(p));
  }
}
